import React, { useCallback, useState, useEffect, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { WithTranslation, withTranslation } from 'react-i18next';

import Slot from '../../Slot';
import LoadingProgress from '../../../../../../../../components/LoadingProgress';

import { useStyles } from './styles';

interface ITabContent extends WithTranslation {
  slots: any[];
  isLoading: boolean;
  noSlotsText: string | ReactNode;
  onClick?: (() => void) | null;
}

const TabContent = ({
  slots,
  isLoading,
  noSlotsText,
  onClick,
  t: translate,
}: ITabContent) => {
  const classes = useStyles();

  const [isNextLoading, setIsNextLoading] = useState(false);

  const handleClick = useCallback(() => {
    if (onClick) {
      setIsNextLoading(true);
      onClick();
    }
  }, [onClick]);

  useEffect(() => {
    if (!isLoading) {
      setIsNextLoading(false);
    }
  }, [isLoading]);

  const renderSlots = () => {
    if (slots.length > 0) {
      return slots.map((slot) => <Slot key={slot.eventId} slot={slot} />);
    }

    return <Typography sx={classes.noSlotsText}>{noSlotsText}</Typography>;
  };

  if (isLoading && !isNextLoading && !slots.length) {
    return <LoadingProgress />;
  }

  return (
    <Box sx={classes.root}>
      <Box sx={classes.slots}>{renderSlots()}</Box>

      {onClick && slots.length > 0 ? (
        <Box sx={classes.actions}>
          <LoadingButton
            onClick={handleClick}
            sx={classes.button}
            disabled={isNextLoading}
            loading={isNextLoading}
          >
            {translate('ek.officeHours.showMore')}
          </LoadingButton>
        </Box>
      ) : null}
    </Box>
  );
};

export default withTranslation('common')(TabContent);
